export enum OrderTypeEnum {
	MARKET = 'market',
	LIMIT = 'limit',
	STOP = 'stop',
	STOP_LIMIT = 'stop_limit',
	TRAILING_STOP = 'trailing_stop',
}
